import { useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { PencilSquareIcon } from '@heroicons/react/24/outline';

import { useLoginForm } from 'pages/Auth/contexts/LoginStateContext/useLoginForm';
import { useLoginState } from 'pages/Auth/contexts/LoginStateContext/useLoginState';
import { Button } from 'components/Form/Button';

export const PasswordlessSuccess = ({
  passwordlessOnly,
  confirmationText,
  nextStepsText,
}: {
  passwordlessOnly?: boolean;
  confirmationText: string;
  nextStepsText: string;
}) => {
  const { t } = useTranslation();
  const { control } = useLoginForm();
  const emailValue = useWatch({ name: 'email', control });
  const { switchToPasswordLogin, switchToPasswordlessLogin } = useLoginState();

  return (
    <div className="flex flex-col items-center gap-6">
      <div className="text-center text-sm text-gray-900">
        {confirmationText}
        <ChangeEmailButton email={emailValue} onChangeEmail={switchToPasswordlessLogin} />
        {nextStepsText}
      </div>
      {passwordlessOnly ? null : (
        <Button
          type="button"
          variant="text"
          className="mt-2 text-gray-900! underline"
          fullWidth
          analyticsId="login:toggle-login-method"
          onClick={switchToPasswordLogin}
        >
          {t('auth:change-method.loginWithPassword')}
        </Button>
      )}
    </div>
  );
};

const ChangeEmailButton = ({ email, onChangeEmail }: { email: string; onChangeEmail: () => void }) => {
  return (
    <div className="flex items-center justify-center py-2">
      <span className="text-sm font-semibold text-gray-900">{email}</span>
      <Button
        size="extra-small"
        onClick={onChangeEmail}
        iconOnly
        LeftIcon={PencilSquareIcon}
        variant="minimal"
        analyticsId="login:change-passwordless-email"
      />
    </div>
  );
};
